export const setAllEmailTemplateDetails=(data)=>{
    return {
        type: "SET_ALL_EMAIL_TEMPLATE_DETAILS",
        info: data,
    }
}
export const nullAllEmailTemplateDetails=()=>{
    return{
        type:"NULL_ALL_EMAIL_TEMPLATE_DETAILS",
        info: null
    }
}
export const getAllEmailTemplateDetails=()=>{
    return {
        type: "GET_ALL_EMAIL_TEMPLATE_DETAILS",
        
    }
}
